/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_View_On_WebInputs */

const vi_shop_group_view_on_web = /** @type {(inputs: Shop_Group_View_On_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem trên web`)
};

/**

* @param {Shop_Group_View_On_WebInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_view_on_web = /** @type {((inputs?: Shop_Group_View_On_WebInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_View_On_WebInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_view_on_web(inputs)
});